import {Box, Typography} from "@mui/material";
import React from "react";

export default function runtimeColumn(){
    return {
        name: 'time',
        label: 'Runtime',
        options: {
            customBodyRowRenderLite: value =>  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Typography>{value}</Typography>
            </Box>,
        },
    }
}